<template>
    <div>
        <rkm-row>
            <rkm-col>
                <rkm-form-radio-group
                    :validations="validations.finalizada"
                    label="Internação finalizada"
                    v-model="model.finalizada"
                >
                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                </rkm-form-radio-group>
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
export default {
    computed: {
        validations() {

            return {
                finalizada: {},
            }
        },
    },
    props: {
        model: { type: Object, required: true },
    }
}
</script>